import BuildingIcon from "@/components/icons/building-icon"
import HomeIcon from "@/components/icons/home-icon"
import SimulatorIcon from "@/components/icons/simulator-icon"

const SELECT_CARD_META = {
  org: {
    color: "text-blue-500",
    icon: BuildingIcon,
    path: "/select/org"
  },
  apt: {
    color: "text-green-500",
    icon: HomeIcon,
    path: "/select/apt"
  },
  simulator: {
    color: "text-purple-500",
    icon: SimulatorIcon,
    path: "/simulator"
  }
}

export const selectBundle = {
  title: {
    ko: "옥내급수관 누수탐지 시스템",
    en: "Leak Detection System",
    es: "Sistema de deteccion de fugas"
  },
  subtitle: {
    ko: "이용하실 서비스를 선택해주세요",
    en: "Please select the service you want to use",
    es: "Seleccione el servicio que desea utilizar"
  },
  discription: {
    ko: "시스템 선택",
    en: "System Selection",
    es: "Seleccion del sistema"
  },
  cardMeta: SELECT_CARD_META,
  card: {
    org: {
      title: {
        ko: "수도 사업자",
        en: "Water Utility",
        es: "Water Utility"
      },
      description: {
        ko: "관리자 및 사업소 전용",
        en: "For administrators and utility offices",
        es: "For administrators and utility offices"
      }
    },
    apt: {
      title: {
        ko: "공동 주택",
        en: "Residential Complex",
        es: "Residential Complex"
      },
      description: {
        ko: "아파트 입주민 전용",
        en: "For apartment residents",
        es: "For apartment residents"
      }
    },
    simulator: {
      title: {
        ko: "누수 시뮬레이터",
        en: "Leak Simulator",
        es: "Leak Simulator"
      },
      description: {
        ko: "데이터 분석 및 실험",
        en: "Data analysis and simulation",
        es: "Data analysis and simulation"
      }
    }
  }
}
